/**
 * Metrics are asked for by posting a list of ids rather than by naming one per request, because a
 * page of flows or agents wants all of their numbers at once and the list outgrows a query string.
 */
import { z } from 'zod';
/** How many ids one request may ask about. Each is a row the warehouse query has to touch. */
export const FLOW_METRIC_MAX_IDS = 500;
/** Body the flow metric endpoints accept, analytical and realtime alike. */
export const FlowMetricRequestSchema = z.object({
    flowIds: z.array(z.uuid()).max(FLOW_METRIC_MAX_IDS).describe('Flows to report on.'),
});
/** Body the agent metric endpoints accept, analytical and realtime alike. */
export const FlowAgentMetricRequestSchema = z.object({
    agentIds: z.array(z.uuid()).max(FLOW_METRIC_MAX_IDS).describe('Agents to report on.'),
});
//# sourceMappingURL=metric.js.map